"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_NAMES = void 0;
exports.FEATURE_NAMES = {
    WELCOME_BOX: 'Welcome Box',
};
